export const PawIcon = ({ className = "h-5 w-5" }) => (
    <svg
        viewBox="0 0 100 100"
        fill="currentColor"
        className={className}
        aria-hidden="true"
    >
        <ellipse cx="50" cy="64" rx="18" ry="14" />
        <circle cx="27" cy="44" r="8" />
        <circle cx="43" cy="33" r="8" />
        <circle cx="59" cy="33" r="8" />
        <circle cx="74" cy="45" r="8" />
    </svg>
);

// A small trail of paws used as a quiet divider between sections.
// Paws are the SECONDARY motif — the line-art cat is the brand character.
export const PawTrail = ({ className = "bg-white text-fern/25" }) => (
    <div
        className={`flex justify-center gap-10 py-5 ${className}`}
        aria-hidden="true"
    >
        <PawIcon className="h-4 w-4 rotate-12" />
        <PawIcon className="h-4 w-4 -translate-y-1 -rotate-12" />
        <PawIcon className="h-4 w-4 rotate-12" />
    </div>
);

// Very faint scattered paws for large background areas.
export const FaintPaws = ({ tone = "light" }) => {
    // Literal class strings so Tailwind picks them up
    const t =
        tone === "light"
            ? ["text-fern/[0.07]", "text-fern/[0.05]", "text-fern/[0.05]", "text-fern/[0.06]", "text-fern/[0.05]"]
            : ["text-cream/[0.05]", "text-cream/[0.04]", "text-cream/[0.05]", "text-cream/[0.04]", "text-cream/[0.05]"];
    return (
        <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
            <PawIcon className={`absolute left-[8%] top-[18%] h-10 w-10 rotate-12 ${t[0]}`} />
            <PawIcon className={`absolute left-[16%] top-[38%] h-7 w-7 -rotate-12 ${t[1]}`} />
            <PawIcon className={`absolute right-[38%] top-[14%] h-8 w-8 -rotate-6 ${t[2]}`} />
            <PawIcon className={`absolute bottom-[14%] left-[10%] h-8 w-8 rotate-6 ${t[3]}`} />
            <PawIcon className={`absolute bottom-[22%] right-[32%] h-7 w-7 -rotate-12 ${t[4]}`} />
        </div>
    );
};

// Watermark paws — as if a cat has quietly wandered through the page.
// Extremely low opacity; sits behind content; light or dark tone.
export const PawWatermark = ({ tone = "light" }) => {
    const t =
        tone === "light"
            ? ["text-fern/[0.06]", "text-fern/[0.045]", "text-fern/[0.05]"]
            : ["text-euca/[0.06]", "text-euca/[0.05]", "text-euca/[0.055]"];
    return (
        <div
            className="pointer-events-none absolute inset-0 overflow-hidden"
            aria-hidden="true"
        >
            <PawIcon className={`absolute right-[6%] top-[10%] h-14 w-14 rotate-12 ${t[0]}`} />
            <PawIcon className={`absolute left-[4%] top-[46%] h-10 w-10 -rotate-12 ${t[1]}`} />
            <PawIcon className={`absolute bottom-[8%] right-[18%] h-12 w-12 rotate-6 ${t[2]}`} />
        </div>
    );
};
